export var tableMixin = {
  data: () => ({
    selectedItem: null,
  }),
  methods: {
    selectItem(event) {
      if (event.value === true) {
        this.selectedItem = event.item
      } else {
        this.selectedItem = null
      }
    },
  },
}
